import { ChevronDown } from "lucide-react";
import type { DisclosureProps } from "../types/layout.js";

export function Disclosure({
  title,
  description,
  controlId,
  children,
  className = "",
  ...props
}: DisclosureProps) {
  return (
    <details
      className={`group min-w-0 rounded-2xl border border-border/60 bg-background p-5 shadow-sm sm:p-6 ${className}`}
      {...props}
    >
      <summary
        className="flex cursor-pointer list-none items-center gap-3 rounded text-sm font-medium focus-visible:outline-none focus-visible:ring-3 focus-visible:ring-ring/30"
        data-control-id={controlId}
      >
        <span className="min-w-0 flex-1">{title}</span>
        <ChevronDown
          aria-hidden="true"
          className="size-4 shrink-0 text-muted-foreground transition-transform group-open:rotate-180"
        />
      </summary>
      {description ? (
        <p className="mt-3 text-sm leading-relaxed text-muted-foreground">{description}</p>
      ) : null}
      {children}
    </details>
  );
}
